import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ProgressBar from "react-bootstrap/ProgressBar";
import { FaDownload } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import "./ObjectiveItem.css";

function ObjectiveItem({
  id,
  title,
  user_comment,
  approver_comment,
  grade,
  weight,
  evidence,
  handleDownloadEvidence,
}) {
  const { t } = useTranslation();

  return (
    <Col className="objective-wrapper">
      {evidence === "" ? (
        <></>
      ) : (
        <Col className="objective-menu right">
          <span
            className="download-link"
            onClick={() => handleDownloadEvidence(evidence)}
          >
            <FaDownload />
          </span>
        </Col>
      )}

      <Col className="objective mb-4" key={id}>
        <Col className="mb-4">
          <Row className="align-items-center">
            <Col lg={1} className="center mb-2">
              <span className="objective-weight">{weight}</span>
            </Col>
            <Col lg={11} className="objective-header mb-2">
              <h5>{title}</h5>
            </Col>
          </Row>
        </Col>

        <Col className="mb-3">
          <Col className="objective-user-feedback mb-3">
            <h6>{t("Reportes.ComentarioUsuario")}</h6>
            <p>{user_comment}</p>
          </Col>
          <Col className="objective-approver-feedback">
            <h6>{t("Reportes.ComentarioJefeDirecto")}</h6>
            <p>{approver_comment}</p>
          </Col>
        </Col>

        <Col>
          <Row className="align-items-center">
            <Col lg={11}>
              <ProgressBar now={grade} />
            </Col>
            <Col lg={1} className="objective-grade center">
              <p>{grade}</p>
            </Col>
          </Row>
        </Col>
      </Col>
    </Col>
  );
}

export default ObjectiveItem;
